<template>
  <div :class="{'error': hasHint}" class="payment__list list">
    <div v-show="hasHint" class="list__message list__message--error">
      <span>{{ hint }}</span>
    </div>
    <ul class="list__main">
      <li
        v-for="(item, index) in items"
        :key="index" class="list__item"
        :class="{'selected': isSelected(item)}"
        @click="select(item)">
        <span class="list__check"/>
        <span class="list__option">{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PaymentSelect',
  props: {
    items: Array,
    hint: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    selected: Object,
  }),
  methods: {
    select(item) {
      this.selected = item;
      this.$emit('selected', item);
    },
    isSelected(item) {
      return this.selected === item;
    },
  },
  computed: {
    hasHint() {
      return !!this.hint;
    },

  }
};
</script>

<style lang="scss" scoped>
$border-radius: 6px;

.list {
  width: 100%;

  &__main {
    border: 1px solid var(--color-grey-5);
    border-radius: $border-radius;
    flex: 1;

    .error & {
      border-color: var(--color-error);
    }
  }

  &__item {
    align-items: center;
    color: var(--color-grey-5);
    cursor: pointer;
    display: flex;
    gap: 10px;
    padding: 12px 16px;
    transition: 0.15s ease-in;

    & + & {
      border-top: 1px solid var(--color-grey-5);
    }

    &:first-of-type {
      border-radius: $border-radius $border-radius 0 0;
    }

    &:last-of-type {
      border-radius: 0 0 $border-radius $border-radius;
    }

    &:hover,
    &.selected {
      background: var(--color-terciary-lighten-4);
      color: var(--color-primary-lighten-2);

      .list__check::before {
        opacity: 1;
      }
    }
  }

  &__check {
    border: 1px solid;
    height: 16px;
    width: 16px;

    &,
    &::before {
      border-radius: 50%;
    }

    &::before {
      background: var(--color-primary-lighten-2);
      content: '';
      display: block;
      height: 10px;
      margin: 0 auto;
      opacity: 0;
      position: relative;
      top: calc(50% - 5px);
      transition: 0.15s ease-in;
      width: 10px;
    }
  }

  &__message {
    font-size: var(--font-size-2);

    &--error {
      color: var(--color-error);
      margin-bottom: 16px;
      text-align: left;

      &::before {
        background: url(../../../assets/img/icons/error.svg) center center no-repeat;
        background-size: contain;
        content: '';
        display: inline-block;
        height: 12px;
        margin-right: 8px;
        position: relative;
        width: 12px;
      }
    }
  }
}

</style>
